/*
 * Copyright (c) 2017, Globo.com <https://github.com/globocom/megadraft-table-plugin>
 *
 * License: MIT
 */

import React from 'react';

export function PluginIcon({ className = '' }) {
  return (
    <svg
      style={{ margin: '-9px 0 0 -9px' }}
      className={className}
      width="17"
      height="17"
      viewBox="0 0 8 8"
      version="1.1"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="test" fillRule="nonzero">
          <circle id="Oval" fill="#FFFFFF" cx="4" cy="4" r="4"></circle>
          <circle id="Oval" fill="#000000" cx="4" cy="4" r="3"></circle>
        </g>
      </g>
    </svg>
  );
}

export function HighlightIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <path
        d="M20.0526316,8 L3.94736842,8 C3.42631579,8 3,8.73125 3,9.625 L3,19.375 C3,20.26875 3.42631579,21 3.94736842,21 L20.0526316,21 C20.5736842,21 21,20.26875 21,19.375 L21,9.625 C21,8.73125 20.5736842,8 20.0526316,8 L20.0526316,8 Z M3,3 L3,6 L21,6 L21,3 L3,3 L3,3 Z"
        id="Shape"
        fill="#999999"
      ></path>
    </svg>
  );
}

export function PlusIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <path fill="#000000" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </svg>
  );
}

export function CloseIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <path
        fill="#000000"
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
      />
    </svg>
  );
}
